import ReactHtmlParser from 'components/UI/HtmlParser';
import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import AsyncSelect from 'react-select/async';
import BaseSelect from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { ThemeContext } from 'utils/context';
import { getSelectHelpers } from 'utils/theme-helpers';
import { withFormHandler } from 'components/UI/Input/FormComponent';

function Select({
    onChange, path, async, creatable, error, printErrors, containerClassName, errorClassName, readOnly,
    options, type, value, placeholder, loadOptions, disabled, defaultValue, isMulti, clearAfterChange, styles, formatCreateLabel,
})
{
    const {
        darkMode,
    } = useContext(ThemeContext);
    const [selectValue, setSelectValue] = useState(value);
    const themeStyles = getSelectHelpers({ error: error && printErrors, darkMode, controlPadding: styles?.padding });

    const parsedError = Array.isArray(error) ? error[0] ?? '' : error;
    const errorContent = parsedError && printErrors ? <span className={`${errorClassName} tw-text-sm tw-text-red-600 dark:tw-text-[#FF565D]`}>{ReactHtmlParser(parsedError)}</span> : null;

    const handleChange = (_value) =>
    {
        if (!clearAfterChange)
        {
            setSelectValue(_value);
        }
        if (onChange) onChange(_value, path);
    };

    useEffect(() =>
    {
        handleChange(value);
    }, [value]);

    // Defining the react-select component to be returned
    const getReactSelectComponent = () =>
    {
        let FinalSelect = BaseSelect;

        if (async)
        {
            FinalSelect = AsyncSelect;
        }

        if (creatable)
        {
            FinalSelect = CreatableSelect;
        }

        return FinalSelect;
    };

    const FinalSelect = getReactSelectComponent();

    return (
        <div className={`tw-w-full ${containerClassName}`}>
            <FinalSelect
                menuPortalTarget={document.body}
                defaultValue={defaultValue}
                onChange={handleChange}
                styles={themeStyles}
                isMulti={isMulti}
                readOnly={readOnly}
                loadOptions={loadOptions}
                options={options}
                type={type}
                value={selectValue || ''}
                placeholder={placeholder}
                isDisabled={disabled}
                formatCreateLabel={(userInput) => `${formatCreateLabel} ${userInput}`}
            />
            {errorContent}
        </div>
    );
}

Select.defaultProps = {
    async: false,
    creatable: false,
    error: '',
    printErrors: true,
    type: 'text',
    readOnly: false,
    clearAfterChange: false,
    placeholder: '',
    containerClassName: '',
    isMulti: false,
    styles: {},
    formatCreateLabel: 'Create ',
    loadOptions: () =>
    {},
};

Select.propTypes = {
    async: PropTypes.bool,
    creatable: PropTypes.bool,
    containerClassName: PropTypes.string,
    error: PropTypes.node,
    errorClassName: PropTypes.string,
    onChange: PropTypes.func,
    clearAfterChange: PropTypes.bool,
    defaultValue: PropTypes.any,
    loadOptions: PropTypes.func,
    path: PropTypes.string,
    printErrors: PropTypes.bool,
    readOnly: PropTypes.bool,
    type: PropTypes.string,
    value: PropTypes.any,
    options: PropTypes.array,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    isMulti: PropTypes.bool,
    styles: PropTypes.object,
    formatCreateLabel: PropTypes.string,
};

export default withFormHandler(Select);
